var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.204,
    height: 66.204,
    viewBox: "0 0 66.204 66.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(-5167.054 -199.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 63.369,
    height: 63.369,
    rx: 3.447,
    transform: "translate(5168.471 201.007)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5193.244 209.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5209.903 209.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5176.584 225.779)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5193.244 225.779)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5209.903 225.779)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5176.584 242.438)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5193.244 242.438)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 13.824,
    height: 13.824,
    rx: 1.235,
    transform: "translate(5209.903 242.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock2);
export default __webpack_public_path__ + "static/media/iconBlock2.e6ecfa3ed93e3cc06e7fcfabcdd322ae.svg";
export { ForwardRef as ReactComponent };